import { render, staticRenderFns } from "./add-material-group-dialog.vue?vue&type=template&id=4c5367c9&scoped=true&"
import script from "./add-material-group-dialog.vue?vue&type=script&lang=js&"
export * from "./add-material-group-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5367c9",
  null
  
)

export default component.exports